import { __rest, __assign } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import Table$2 from './Desktop/Table.js';
import Table$1 from './Mobile/Table.js';
import useIsLowerResolution from '../../hooks/useIsLowerResolution.js';

var Table = forwardRef(function (_a, ref) {
    var rows = _a.rows, columns = _a.columns, onSort = _a.onSort, seeMoreInfoButtonText = _a.seeMoreInfoButtonText, seeMoreInfoModalTitleText = _a.seeMoreInfoModalTitleText, props = __rest(_a, ["rows", "columns", "onSort", "seeMoreInfoButtonText", "seeMoreInfoModalTitleText"]);
    var isLowerResolution = useIsLowerResolution();
    return isLowerResolution ? (React.createElement(Table$1, __assign({ rows: rows, columns: columns, seeMoreInfoButtonText: seeMoreInfoButtonText, seeMoreInfoModalTitleText: seeMoreInfoModalTitleText, ref: ref }, props))) : (React.createElement(Table$2, __assign({ ref: ref, rows: rows, columns: columns, onSort: onSort }, props)));
});

export { Table as default };
